export const GRIMTILE_NAVIGATION = [
  {
    anchor: '/',
    text: '← Back to Mutopi',
    options: {
      sx: {
        color: 'grey.400',
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: 13,
        letterSpacing: 2,
        textTransform: 'uppercase',
        '&:hover': { color: 'grey.100', backgroundColor: 'transparent' },
      },
    },
  },
]
